import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { KeyRound, Copy, Download } from "lucide-react";

export function RecoveryCodes({ codes, onDone, doneLabel = "Done" }) {
    const copy = () => { navigator.clipboard.writeText(codes.join("\n")); toast.success("Copied to clipboard"); };
    const download = () => {
        const blob = new Blob([`ProcureEd recovery codes\n\n${codes.join("\n")}\n`], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = "procureed-recovery-codes.txt"; a.click();
        URL.revokeObjectURL(url);
    };
    return (
        <div className="space-y-4" data-testid="recovery-codes">
            <div className="flex items-center gap-2 text-brand-emerald font-semibold"><KeyRound className="h-5 w-5 text-brand-teal" /> Your recovery codes</div>
            <p className="text-sm text-muted-foreground">Save these somewhere safe. Each code works once if you lose access to your authenticator app. They won't be shown again.</p>
            <div className="grid grid-cols-2 gap-2 font-mono text-sm bg-secondary/40 rounded-lg p-4">
                {codes.map((c) => <span key={c} data-testid="recovery-code">{c}</span>)}
            </div>
            <div className="flex flex-wrap gap-2">
                <Button variant="outline" onClick={copy} className="rounded-lg" data-testid="copy-recovery-codes"><Copy className="h-4 w-4 mr-1" /> Copy</Button>
                <Button variant="outline" onClick={download} className="rounded-lg" data-testid="download-recovery-codes"><Download className="h-4 w-4 mr-1" /> Download</Button>
                {onDone && <Button onClick={onDone} className="ml-auto bg-brand-emerald hover:bg-brand-emeraldhover rounded-lg" data-testid="recovery-done">{doneLabel}</Button>}
            </div>
        </div>
    );
}
